import { render, staticRenderFns } from "./cancerStatistics.vue?vue&type=template&id=507c5002&scoped=true"
import script from "./cancerStatistics.vue?vue&type=script&lang=js"
export * from "./cancerStatistics.vue?vue&type=script&lang=js"
import style0 from "./cancerStatistics.vue?vue&type=style&index=0&id=507c5002&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507c5002",
  null
  
)

export default component.exports